import { HTTP_STATUSES } from "@miplatform/constants";
import { ENVIRONMENT_SERVICE } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_LOGGGING = `${ENVIRONMENT_SERVICE}/logging`;

export const logging = {
  getConnectionString: async () => {
    const options = await apiOptions({
      url: `${API_LOGGGING}/connectionstring/`,
      method: "get",
    });
    const response = await apiRequest(options);
    if (response.status === HTTP_STATUSES.OK) {
      return response.data;
    }
    return null;
  },
  getGoogleApiKey: async () => {
    const options = await apiOptions({
      url: `${API_LOGGGING}/googleapikey/`,
      method: "get",
    });
    const response = await apiRequest(options);
    return response;
  }
};
